<template>
  <div class="sa-donation-list__empty" role="status">
    <p class="sa-donation-list__empty-title">{{ $t('Dashboard.Home.Empty.Title') }}</p>
    <p class="sa-donation-list__empty-body">{{ $t('Dashboard.Home.Empty.Body') }}</p>
  </div>
</template>
